import type { AgencyLink } from '@/services/ws-orders/src/main/resources/rest-api';
import type { IdentityRoleMap } from '@/js/libs/use-auth';

import { APPROVALS, DRAFTS, RUNNING, PREPAYMENT } from 'src/constants.tsx';
import { PositionsType } from './types.ts';

const getLinksByPermissions = (links: AgencyLink[], permissions: Partial<IdentityRoleMap>): AgencyLink[] => {
  if (!permissions.SELF_BOOKING) {
    return links.filter((status) => status.name !== DRAFTS && status.name !== APPROVALS);
  }
  return links.filter((status) => status.name !== PREPAYMENT);
};

const getLinksByPositionsType = (links: AgencyLink[], positionsType: PositionsType): AgencyLink[] => {
  switch (positionsType) {
    case PositionsType.PRINT:
      return links.filter((status) => status.name !== RUNNING);
    case PositionsType.TV:
    case PositionsType.RADIO:
      return links.filter((status) => status.name !== DRAFTS && status.name !== APPROVALS);
    case PositionsType.CAMPAIGNS:
    case PositionsType.DIGITAL:
    default:
      return links;
  }
};

export const getStatuses = (
  links: AgencyLink[] | undefined,
  positionsType: PositionsType,
  permissions: Partial<IdentityRoleMap>,
): string[] => {
  if (!links?.length) {
    return [];
  }

  const permissionLinks = getLinksByPermissions(links, permissions);
  const positionsTypeLinks = getLinksByPositionsType(permissionLinks, positionsType);

  return positionsTypeLinks.map((link) => link.name);
};
